module.exports = __webpack_public_path__ + "static/media/fonts.287a213b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts.scss
// module id = 151
// module chunks = 0